export const skeletonBadges = [
    {
    name:"Technical",
    link:process.env.REACT_APP_API_URI+"/xcb/skeleton/skeleton-badge.PNG",
    styles:{
        badgeTitle:{
            top:"27%",
            
        },
        badgeDifficulty:{
            top:"41%",
            
        },
        badgeType:{
            top:"53%",
            color:"black"
        }
    }
},  
    {
    name:"Digital",
    link:process.env.REACT_APP_API_URI+"/xcb/skeleton/skeleton-badge-2.PNG",
    styles:{
        badgeTitle:{
            top:"27%",
            
        },
        badgeDifficulty:{
            top:"41%",
            
        },
        badgeType:{
            top:"53%",
            color:"white"
        }
    }
},
]
